import { INIT_FILES } from '../type';
import axiosInstance from '../../config/axios.config';
import { addError } from './error.action';
import { downloadFile } from '../../utils/downloadFile';
import { handleRequestError } from '../../utils/handleRequestError';
import { success } from './loader.action';

export const initFiles = (files) => ({
  type: INIT_FILES,
  payload: files,
});

export const initFilesFromServer = () => async (dispatch) => {
  try {
    const { data } = await axiosInstance('/api/files');
    if (data) {
      dispatch(initFiles(data));
    }
  } catch (error) {
    console.log(error);
  }
};

// добавление новой папки
export const newFolderFromServer = (payload) => async (dispatch) => {
  try {
    const response = await axiosInstance.post('/api/files/folder', payload);
    if (response.status === 201) {
      dispatch(success());
      dispatch(initFilesFromServer());
    }
    dispatch(success());
  } catch (error) {
    console.log(error);
  }
};

// перемещение файла
export const moveFileToFolderFromServer = (payload, fileId) => async (dispatch) => {
  try {
    const response = await axiosInstance.patch(`/api/files/${fileId}`, payload);
    if (response.status === 200) {
      dispatch(success());
      dispatch(initFilesFromServer());
    }
  } catch (error) {
    console.log(error);
    const message = error?.response?.data || 'Возникла непредвиденная ошибка, обратитесь к администратору системы.';
    dispatch(addError(message));
  }
};

// добавление нового file
export const newFileFromServer = (payload, name) => async (dispatch) => {
  try {
    const response = await axiosInstance.post('/api/files/file', payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    if (response.status === 201) {
      dispatch(success());
      dispatch(addError({ error: `Файл ${name} успешно добавлен!` }));
      dispatch(initFilesFromServer());
    }
  } catch (error) {
    console.log(error);
  }
};

export const removeFile = (payload) => async (dispatch) => {
  try {
    const response = await axiosInstance.delete(`/api/files/${payload}`);
    if (response.status === 200) {
      dispatch(initFilesFromServer());
    }
  } catch (error) {
    const message = error?.response?.data || 'Возникла непредвиденная ошибка, обратитесь к администратору системы.';
    dispatch(addError(message));
    console.log(error);
  }
};

export const downloadFileFromServer = (payload) => async (dispatch) => {
  try {
    const { data } = await axiosInstance(
      `${process.env.REACT_APP_UPLOADS}?fileId=${encodeURIComponent(payload?.fileId)}&fileName=${encodeURIComponent(
        payload?.fileName
      )}`,
      { responseType: 'blob' }
    );
    if (data) {
      const filename = payload?.fileName;
      downloadFile(data, filename);
    }
  } catch (error) {
    handleRequestError(error, dispatch);
    console.log(error);
  }
};
